import './TargetEmojiDialog.styles.scss';

import { Dropdown } from 'primereact/dropdown';
import { OverlayPanel } from 'primereact/overlaypanel';
import React, {
  FC,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useStompClient } from 'react-stomp-hooks';

import { TargetEmojiMessageRequest } from '../../../model/chat/TargetEmojiMessageRequest';
import { Player } from '../../../model/Player';
import chatStore from '../../../store/ChatStore';
import playerStore from '../../../store/PlayerStore';
import { WEventType } from '../../../websocket/events/WEventType';
import { TargetEmojiDialogProps } from './TargetEmojiDialog.types';

const TargetEmojiDialog: FC<TargetEmojiDialogProps> = ({
  toggleEvent,
  player,
  table,
  onHide,
}) => {
  const overlayRef = useRef<OverlayPanel>(null);
  const client = useStompClient();

  const [selectedBot, setSelectedBot] = useState<Player>();
  const [botPlayers, setBotPlayers] = useState<Player[]>([]);

  useEffect(() => {
    if (overlayRef.current && toggleEvent) {
      overlayRef.current.toggle(toggleEvent);
    } else if (overlayRef.current) {
      overlayRef.current.hide();
    }
  }, [toggleEvent]);

  const getEmojiNumbers = useCallback((toMyself: boolean) => {
    return toMyself
      ? [
          1, 2, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 20, 22, 23, 24, 25, 26,
          27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
          44, 45,
        ]
      : [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 13, 14, 15];
  }, []);

  const getEmojiImage = useCallback(
    (imageNumber: string, toMyself: boolean): string => {
      return toMyself
        ? `/assets/xpoker_self_emoji/${imageNumber}.png`
        : `/assets/emoji_xpoker/${imageNumber}.png`;
    },
    [],
  );

  const sendEmoji = (emojiNumber: string, pid: string, nick: string): void => {
    chatStore.sendMessage(client, {
      eventType: WEventType.TARGET_CHAT_EVENT,
      targetPid: player.pid,
      text: emojiNumber,
      emoji: true,
      tableId: table.id,
      room: table.room,
      pid: pid,
      nick: nick,
    } as TargetEmojiMessageRequest);
    overlayRef.current.hide();
  };

  useEffect(() => {
    const bots = playerStore.findBots(table.players);
    setBotPlayers(bots);
    if (selectedBot) {
      setSelectedBot(bots.find(bot => bot.pid === selectedBot.pid));
    }
    if (bots.length) {
      setSelectedBot(bots[0]);
    }
  }, [table.players]);

  const emojiContent = useMemo(() => {
    if (selectedBot) {
      return getEmojiNumbers(selectedBot.pid === player.pid).map(
        emojiNumber => {
          const imageNumber = String(emojiNumber);
          return (
            <span
              className="cursor-pointer m-2"
              key={imageNumber}
              onClick={() =>
                sendEmoji(imageNumber, selectedBot.pid, selectedBot.nick)
              }
            >
              <img
                width="40px"
                height="40px"
                src={getEmojiImage(imageNumber, player.pid === selectedBot.pid)}
                alt={`emoji_${imageNumber}`}
              />
            </span>
          );
        },
      );
    }
  }, [client, selectedBot]);

  return (
    <OverlayPanel
      onHide={() => onHide(null)}
      onClick={e => e.stopPropagation()}
      ref={overlayRef}
      className="TargetEmojiDialog-Component"
      showCloseIcon
      dismissable={false}
    >
      <div className="header p-2">
        <h3 className="m-0">Target emoji</h3>
      </div>
      <div className="target-emoji-content p-2">
        <div className="mt-2 ms-2">
          <label
            className="fw-bold d-block mb-2"
            htmlFor="bot-players-dropdown"
          >
            Sender
          </label>
          <Dropdown
            id="bot-players-dropdown"
            className="bot-selector p-0 col-3 w-75"
            value={selectedBot}
            onChange={e => setSelectedBot(e.value)}
            invalid={!selectedBot}
            options={botPlayers}
            optionLabel="nick"
            placeholder="Bot"
          />
        </div>
        <div className="mt-3">{emojiContent}</div>
      </div>
    </OverlayPanel>
  );
};

export default TargetEmojiDialog;
